'use client';

import { useState, useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { Stack, Typography, Divider } from '@mui/material';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'hooks';
import { readOptionsFinancialYear } from '@/redux/actions';
// import { DropDownInput } from 'components/input';

const selector = (state) => ({
  optionsFinancialYearInfo: state.optionsFinancialYearInfo,
});

function PortalHeader({ header }) {
  const { optionsFinancialYearInfo } = useSelector(selector, shallowEqual);
  const dispatch = useDispatch();
  const [financialYearId, setFinancialYearId] = useState(null);

  useEffect(() => {
    dispatch(readOptionsFinancialYear());
  }, [dispatch]);

  useEffect(() => {
    const financialYears = get(optionsFinancialYearInfo, 'data.financialYears', []);
    if (financialYears.length > 0 && financialYearId === null) {
      setFinancialYearId(financialYears[0].value);
    }
  }, [optionsFinancialYearInfo, financialYearId]);

  return (
    <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', px: 2, pt: 2 }}>
      {/* Left Part */}
      <Stack sx={{ width: '50%' }}>
        <Typography variant='h2' color='secondary' sx={{ pb: 1.5, fontWeight: 'bold', textTransform: 'uppercase' }}>
          {header}
        </Typography>
        <Divider sx={{ height: '4px', backgroundColor: 'primary.main' }} />
      </Stack>

      {/* Right Part */}
      {/* <Stack gap={1} direction="row" sx={{ alignItems: 'center', width: '29%' }}>
        <Typography variant='body1' color='info.700' sx={{ width: '90%' }}>
          Financial Year:
        </Typography>

        <DropDownInput
          value={financialYearId}
          options={get(optionsFinancialYearInfo, 'data.financialYears', [])}
          onChange={(e) => setFinancialYearId(e.target.value)}
        />
      </Stack> */}
    </Stack>
  );
}

PortalHeader.propTypes = {
  header: PropTypes.string,
};

export default PortalHeader;
